module.exports = __webpack_public_path__ + "img/hortensia.0d58b162.jpg";